export default __webpack_public_path__ + "static/media/Pregacap-75-eng.02ac1ece.jpg";